import { render, staticRenderFns } from "./AmOverlay.vue?vue&type=template&id=74b03c88&scoped=true&"
import script from "./AmOverlay.vue?vue&type=script&lang=js&"
export * from "./AmOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b03c88",
  null
  
)

export default component.exports